import {
  createApolloClientWithCache,
  createApolloClientWithoutCacheProductService,
} from 'src/scripts/templates/_shared/apolloClientUtils';

export const CartApolloClient = createApolloClientWithCache();

export const CartPSClient = createApolloClientWithoutCacheProductService();
